import { createSelector } from "@ngrx/store";

import { AppState } from "../app.state";

import { NotificationFeatureState } from "./notification.state";

export const selectFeatureState = (state: AppState) => state.notification;

///////////////////////////////////////////////////////////////////////////////////////
// Single State Slice Selector
///////////////////////////////////////////////////////////////////////////////////////

export const selectNotificationMessages = createSelector(
  selectFeatureState,
  (state: NotificationFeatureState) => state.notificationMessages,
);
